<template>
  <div id="app">
    <headnav></headnav>
    <router-view />
    <footnav></footnav>
  </div>
</template>

<script>
import headnav from "./components/headnav.vue";
import footnav from "./components/footnav.vue";
export default {
  name: "App",
  components: {
    headnav,

    footnav
  },
  created() {
    let abc = document.getElementsByTagName("body")[0];
    let zoomnum = document.body.clientWidth / 1920;
    abc.style.zoom = zoomnum;
  },
  methods: {
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: rgba(216, 196, 196, 0.4);
}

/*滚动条 阴影~圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(128, 128, 128, 0.4);
  border-radius: 10px;
  background-color: #f5f5f5;
}

/*滑块 阴影~圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(128, 128, 128, 0.4);
  background-color: rgba(149, 147, 147, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/App.vue